import React from 'react';
import {Provider} from 'react-redux';
import {Route} from 'react-router-dom';
import {ConnectedRouter} from 'connected-react-router';
import Notification from '@pluto/notification';
import configureAxios from '@pluto/rest/configureAxios';
import Login from '../Login/LoginConnected';
import AppRouter from './AppRouter/AppRouterConnected';
import {baseRoutes} from './AppRouter/routes';
import {configureStore, history} from './store';
import '@pluto/styles/overrides.scss';
import './App.scss';

const store = configureStore();
configureAxios();

export default () => {
    return (
        <Provider store={store}>
            <ConnectedRouter history={history}>
                <Route exact path={[baseRoutes.root, baseRoutes.login]}>
                    <Login />
                </Route>
                <AppRouter />
            </ConnectedRouter>
            <Notification />
        </Provider>
    );
};
